import { DocumentNode } from "@apollo/client";

import FlashContext from "components/FlashMessages/FlashContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";
import { ApiKey, ApiKeyUpdateInput } from "types/generated";

import { UPDATE_PERSONAL_API_KEY } from "./gql";

type UsePersonalApiKeysUpdateOptions = {
  callback?: () => void;
  refetchQueries?: DocumentNode[];
};

const usePersonalApiKeyUpdateMutation = createDefaultMutationHook(UPDATE_PERSONAL_API_KEY);

const usePersonalApiKeysUpdate = ({
  callback,
  refetchQueries,
}: UsePersonalApiKeysUpdateOptions) => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [updatePersonalApiKey, { loading }] = usePersonalApiKeyUpdateMutation({ refetchQueries });

  const onUpdate = (id: ApiKey["id"], input: ApiKeyUpdateInput) => {
    updatePersonalApiKey({ id, input }, (data) => {
      if (!data?.apiKeyUpdate) {
        return;
      }

      reportSuccess({ message: "API key updated successfully" });
      callback?.();
    });
  };

  return { onUpdate, loading };
};

export default usePersonalApiKeysUpdate;
